import type { CasinoConfigGameRow } from "../../../utils/game-utils/gamesUtils";

// Returns tag IDs (not names) so TagModal can match against AdminTag.id for display.
function normalizeTags(tags: unknown): string[] {
  if (!Array.isArray(tags)) return [];
  return tags
    .map((tag) => {
      if (typeof tag === "string") return tag;
      if (tag && typeof tag === "object") {
        const obj = tag as { tag_id?: unknown; id?: unknown; name?: unknown };
        const id = obj.tag_id ?? obj.id;
        if (typeof id === "string") return id;
        if (typeof obj.name === "string") return obj.name;
      }
      return String(tag ?? "");
    })
    .filter(Boolean);
}

export function mapAdminTreeGameToRow(
  raw: Record<string, unknown>,
): CasinoConfigGameRow {
  const provider = String(raw.provider ?? "");
  const gameId = String(raw.game_id ?? raw.id ?? "");
  return {
    ...raw,
    provider,
    provider_name: String(raw.provider_name ?? provider),
    game_id: gameId,
    display_game_id: String(raw.display_game_id ?? gameId),
    sub: String(raw.sub ?? ""),
    name: String(raw.name ?? raw.game_name ?? ""),
    tags: normalizeTags(raw.tags),
    is_active: raw.is_active !== false,
    aggregator: Boolean(raw.aggregator),
  } as CasinoConfigGameRow;
}
